import React from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'
import { useAlertContext } from '../../contexts/AlertContext'
import PatternConditionReadView from '../PatternConditionReadView'
import { Pattern } from '../../../builder/contexts/PatternContext'
import { useExitTradingPlan } from '../../hooks/useExitTradingPlan'

const ConditionsTab: React.FC = () => {
  const { selectedAlert } = useAlertContext()

  const [exitTradingPlan, exitTradingPlanLoading] = useExitTradingPlan(
    selectedAlert?.trading?.exitTradingPlanId
  )

  if (!selectedAlert) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="text.secondary">No alert selected</Typography>
      </Box>
    )
  }

  const entryPattern = selectedAlert.pattern as Pattern
  const exitPattern = exitTradingPlan?.pattern as Pattern | undefined

  return (
    <Box>
      {/* Entry Pattern Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
          Entry Pattern
        </Typography>
        <PatternConditionReadView
          pattern={entryPattern}
          isActive={selectedAlert.active}
          liveStatus={true}
        />
      </Box>

      {/* Exit Pattern Section */}
      {selectedAlert.trading?.exitTradingPlanId && exitTradingPlanLoading && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Exit Pattern
          </Typography>
          <CircularProgress size={24} />
        </Box>
      )}

      {selectedAlert.trading?.exitTradingPlanId && exitPattern && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Exit Pattern
          </Typography>
          <PatternConditionReadView
            pattern={exitPattern}
            isActive={exitTradingPlan?.active}
            liveStatus={true}
          />
        </Box>
      )}
    </Box>
  )
}

export default ConditionsTab
